import StandardLayout from '@/common/layouts/StandardLayout';
import { Button } from 'reactstrap';
import { FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import PayoutStructureTable from './components/PayoutStructureTable';
import ROUTES from '@/routes/routes-enums';
import { replacePathParams } from '@/common/utils/common';
import { useState } from 'react';
import ConfirmModal from '@/components/ConfirmationModal/ConfirmModal';
import { toast } from 'react-toastify';
import usePayoutStructures from '@/hooks/usePayoutStructures';

const PayoutStructuresListPage = () => {
  const navigate = useNavigate();

  const { deletePayoutStructureMutation, duplicatePayoutStructureMutation } = usePayoutStructures();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [payoutStructureToDelete, setPayoutStructureToDelete] = useState<any>(null);
  const handleAddPayoutStructure = () => {
    navigate(ROUTES.TOURNAMENT_PAYOUT_STRUCTURE_CREATE);
  };

  const handleEditPayoutStructure = (payoutStructureId: string) => {
    navigate(replacePathParams(ROUTES.TOURNAMENT_PAYOUT_STRUCTURE_DETAILS, { payoutStructureId }));
  };

  const handleDuplicatePayoutStructure = async (payoutStructure: any) => {
    try {
      await duplicatePayoutStructureMutation(payoutStructure.id);
      toast.success('Payout structure duplicated successfully');
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Failed to duplicate payout structure');
    }
  };

  const handleDeletePayoutStructure = (payoutStructure) => {
    setShowDeleteModal(true);
    setPayoutStructureToDelete(payoutStructure);
  };

  const handleConfirmDelete = async () => {
    try {
      await deletePayoutStructureMutation(payoutStructureToDelete?.id ?? '');
      setShowDeleteModal(false);
      toast.success('Payout structure deleted successfully');
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Failed to delete payout structure');
    }
  };

  return (
    <StandardLayout
      pageTitle="Payout Structures"
      headerButton={
        <Button onClick={handleAddPayoutStructure} color="primary" className="d-flex align-items-center gap-2">
          <FaPlus />
          <p className="mb-0">Add Payout Structure</p>
        </Button>
      }
    >
      {showDeleteModal && (
        <ConfirmModal
          title={`Delete Payout Structure - ${payoutStructureToDelete?.name}`}
          message="Are you sure you want to delete this payout structure? There may be tournaments that may be affected by this change."
          onConfirm={handleConfirmDelete}
          onClose={() => {
            setShowDeleteModal(false);
            setPayoutStructureToDelete(null);
          }}
        />
      )}
      <PayoutStructureTable
        onEditPayoutStructure={handleEditPayoutStructure}
        onDuplicatePayoutStructure={handleDuplicatePayoutStructure}
        onDeletePayoutStructure={handleDeletePayoutStructure}
      />
    </StandardLayout>
  );
};

export default PayoutStructuresListPage;
